import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageShell, { PageHeader } from '../common/PageShell';
import useIsMobile from '../../hooks/useIsMobile';
import caseStudies from '../../data/caseStudies';
import { card, cardHover, colors, layout, motion, space, type } from '../../styles/tokens';

const CaseStudyTile = ({ study }) => {
  const [hovered, setHovered] = useState(false);
  const isMobile = useIsMobile();

  return (
    <Link
      to={`/case-studies/${study.id}`}
      style={{
        ...card,
        ...(hovered ? cardHover : {}),
        display: 'block',
        textDecoration: 'none',
        color: 'inherit',
        padding: isMobile ? space[3] : space[4],
        marginBottom: space[3]
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div style={{ ...type.label, marginBottom: space[2] }}>
        {study.kind} <span style={{ margin: '0 4px' }}>◆</span> {study.year}
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'baseline',
          gap: space[2],
          marginBottom: space[2],
          flexWrap: 'wrap'
        }}
      >
        <h3 style={type.h3}>{study.title}</h3>
        <span style={type.meta}>{study.org}</span>
      </div>

      <p style={{ ...type.body, marginBottom: space[3], maxWidth: layout.prose }}>
        {study.summary}
      </p>

      <span style={type.link}>
        Read the case study{' '}
        <span
          style={{
            display: 'inline-block',
            transition: `transform ${motion.fast} ease`,
            transform: hovered ? 'translateX(3px)' : 'translateX(0)'
          }}
        >
          →
        </span>
      </span>
    </Link>
  );
};

const CaseStudiesPage = () => (
  <PageShell>
    <PageHeader title="Case Studies" subtitle="How the decisions actually got made" flourish="◈" />

    <p
      style={{
        ...type.body,
        color: colors.muted,
        maxWidth: layout.prose,
        marginBottom: space[5]
      }}
    >
      Longer write-ups on things I've built — what the user was actually trying to do, what I got
      wrong first, and what I'd do differently. Including the one I decided to stop building.
    </p>

    {caseStudies.map((study) => (
      <CaseStudyTile key={study.id} study={study} />
    ))}
  </PageShell>
);

export default CaseStudiesPage;
